<template>
  <div>
    <el-dropdown class="signupLabel" size="small" trigger="click" @visible-change="openLanguage" @command="selectLang">
      <span class="el-dropdown-link" style="cursor:pointer;">
        <span class="pic_header languageMargin" :class="languageClass"></span>{{currentLanguage}}
        <i :class="onLanguage?'el-icon-arrow-down el-icon--right right-rotate':'el-icon-arrow-down el-icon--right'"></i>
      </span>
      <el-dropdown-menu slot="dropdown" class="languageSelect">
        <el-dropdown-item v-for="(country, i) in countryList" :key="i" :command="country">
          <div class="flex-row-start">
            <!-- <img style="width:16px;height:16px;" :src="$Image(country.img)" alt=""> -->
            <span class="pic_header" :class="country.img"></span>
            <span class="settingSpan">{{country.name}}</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  name: 'language',
  data () {
    return {
      currentLanguage: 'English',
      countryList: [
        // {img: 'pic_1_header', name: '简体中文', click: 'cn'},
        {img: 'pic_2_header', name: 'Deutsch', click: 'de'},
        {img: 'pic_3_header', name: 'English', click: 'en'},
        // {img: 'pic_4_header', name: 'Español', click: 'es'},
        // {img: 'pic_5_header', name: 'Suomi', click: 'fi'},
        // {img: 'pic_6_header', name: 'Pilipino', click: 'fil'}, // 菲律宾element-ui没有
        {img: 'pic_7_header', name: 'Français', click: 'fr'},
        // {img: 'pic_8_header', name: 'עברית', click: 'he'},
        // {img: 'pic_9_header', name: 'हिंदी', click: 'hi'}, // 印地语
        // {img: 'pic_10_header', name: 'Magyar', click: 'hu'},
        // {img: 'pic_11_header', name: 'Italiano', click: 'it'},
        {img: 'pic_12_header', name: '日本語', click: 'ja'}
        // {img: 'pic_13_header', name: '한국의', click: 'kr'},
        // {img: 'pic_14_header', name: 'Bahasa Melayu', click: 'ms'}, // 马来语
        // {img: 'pic_15_header', name: 'Nederlands', click: 'nl'},
        // {img: 'pic_16_header', name: 'Norsk', click: 'no'},
        // {img: 'pic_17_header', name: 'Protuguês', click: 'pt'},
        // {img: 'pic_18_header', name: 'ภาษาไทย', click: 'th'},
        // {img: 'pic_19_header', name: 'Türkçe', click: 'tr'},
        // {img: 'pic_20_header', name: '繁體中文', click: 'tw'},
        // {img: 'pic_21_header', name: 'Tiếng Việt', click: 'vnm'},
        // {img: 'pic_22_header', name: 'isiZulu', click: 'zu'} // 祖鲁语
      ],
      languageClass: 'pic_3_header',
      onLanguage: false
    }
  },
  methods: {
    openLanguage (type) {
      // alert(type)
      if (type) {
        this.onLanguage = true
      } else {
        this.onLanguage = false
      }
    },
    selectLang (current) {
      console.log(current)
      this.currentLanguage = current.name
      this.languageClass = current.img
      localStorage.setItem('language', current.click)
      localStorage.setItem('languageName', current.name)
      localStorage.setItem('languageClass', current.img)
      window.location.reload()
    }
  },
  created () {
    var languageName = localStorage.getItem('languageName')
    if (languageName !== null) {
      this.currentLanguage = languageName
    }
    var languageClass = localStorage.getItem('languageClass')
    if (languageClass !== null) {
      this.languageClass = languageClass
    }
  }
}
</script>
<style>
.pic_header {background-image: url('../../../static/images/language.png'); display: inline-block;width: 16px;height: 16px;border-radius: 50%;}
.pic_1_header {background-position: -0px -0px; width: 16px; height: 16px; }
.pic_2_header {background-position: -16px -0px; width: 16px; height: 16px; }
.pic_3_header {background-position: -32px -0px; width: 16px; height: 16px; }
.pic_4_header {background-position: -48px -0px; width: 16px; height: 16px; }
.pic_5_header {background-position: -64px -0px; width: 16px; height: 16px; }
.pic_6_header {background-position: -80px -0px; width: 16px; height: 16px; }
.pic_7_header {background-position: -96px -0px; width: 16px; height: 16px; }
.pic_8_header {background-position: -112px -0px; width: 16px; height: 16px; }
.pic_9_header {background-position: -128px -0px; width: 16px; height: 16px; }
.pic_10_header {background-position: -144px -0px; width: 16px; height: 16px; }
.pic_11_header {background-position: -160px -0px; width: 16px; height: 16px; }
.pic_12_header {background-position: -176px -0px; width: 16px; height: 16px; }
.pic_13_header {background-position: -192px -0px; width: 16px; height: 16px; }
.pic_14_header {background-position: -208px -0px; width: 16px; height: 16px; }
.pic_15_header {background-position: -224px -0px; width: 16px; height: 16px; }
.pic_16_header {background-position: -240px -0px; width: 16px; height: 16px; }
.pic_17_header {background-position: -256px -0px; width: 16px; height: 16px; }
.pic_18_header {background-position: -272px -0px; width: 16px; height: 16px; }
.pic_19_header {background-position: -288px -0px; width: 16px; height: 16px; }
.pic_20_header {background-position: -304px -0px; width: 16px; height: 16px; }
.pic_21_header {background-position: -320px -0px; width: 16px; height: 16px; }
.pic_22_header {background-position: -336px -0px; width: 16px; height: 16px; }
.languageMargin{
  position:absolute;
  left:-4px;
  top:0;
}
.right-rotate{
  transform: rotateX(180deg);
}
.el-dropdown-link{
  margin-left:15px;
}
.el-dropdown-menu{
  max-height:90%;
  overflow-y: scroll;
}
@media (min-width: 992px) {
  .el-dropdown-menu{
    overflow-y: auto;
  }
}
.signupLabel{
  color:#888;
  font-size: 14px;
}
.settingSpan {
  margin-left: 10px;
  font-family: Helvetica,Arial,sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/languageChange.vue